$(document).ready( function(){
  function setInitialStateFromUrl() {
    var urlParams = new URLSearchParams(window.location.search);
    var sortByParam = urlParams.get('sort_by');

    if (sortByParam) {
      $('.collection-filter__sort--dropdown li').each( function() {        
        if ($(this).attr('value') === sortByParam) {
          $('#SortBy').val(sortByParam);
          $('.sort-button').find('span').text($(this).text())
        }
      })
    }
  }
  setInitialStateFromUrl();
  
  // $('body').on('click','.sort-button', function() {
  //   $('.collection-filter__sort--dropdown').toggleClass('open');
  // })

  // $('body').on('click','.collection-filter__sort--dropdown li', function() {
  //   var selectElement = document.getElementById('SortBy');
  //   var $this = this;
  //   var liValue = $(this).attr('value');
    

  //   var urlParams = new URLSearchParams(window.location.search);
    
  //   urlParams.set('sort_by', liValue);
  //   window.history.replaceState({}, '', window.location.pathname + '?' + urlParams.toString());

  //   if(liValue){
  //     $('#SortBy').val(liValue);
  //     $('.sort-button').find('span').text($($this).text());
  //     var event = new Event('change');
  //     selectElement.dispatchEvent(event);
  //   }else{
  //     var liValue = $($this).attr('value');
  //     $('#SortBy').val(liValue);
  //     var event = new Event('change');
  //     selectElement.dispatchEvent(event);
  //   }

  //   $('.collection-filter__sort--dropdown').removeClass('open');
  // })

  // Open / close sort dropdown
  $('body').on('click', '.collection-filter__sort--dropdown .sort-button', function() {
    var $dropdown = $(this).closest('.collection-filter__sort--dropdown');
    var isOpen = $dropdown.hasClass('open');
    
    $(this).attr('aria-expanded', isOpen ? 'false' : 'true');
    $('.collection-filter__sort--dropdown').toggleClass('open');
  });

  $('body').on( 'keydown', '.collection-filter__sort--dropdown li[tabindex="0"]',function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      $(this).trigger('click');
    }
  }
);


  // Sort option selection
  $('body').on('click', '.collection-filter__sort--dropdown li', function() {
    var selectElement = document.getElementById('SortBy');
    var $this = this;
    var liValue = $(this).attr('value');

    var urlParams = new URLSearchParams(window.location.search);

    urlParams.set('sort_by', liValue);
    window.history.replaceState(
      {},
      '',
      window.location.pathname + '?' + urlParams.toString()
    );

    if (liValue) {
      $('#SortBy').val(liValue);
      $('.sort-button').find('span').text($($this).text());

      var event = new Event('change');
      selectElement.dispatchEvent(event);
    } else {
      var liValue = $($this).attr('value');

      $('#SortBy').val(liValue);

      var event = new Event('change');
      selectElement.dispatchEvent(event);
    }

    $('.collection-filter__sort--dropdown').removeClass('open');

    // ADA: dropdown is now closed
    $('.collection-filter__sort--dropdown')
      .find('.sort-button')
      .attr('aria-expanded', 'false');
  });


  $(".menu_level_1 > li > .slide-nav__button").click(function () {
    var $this = $(this);
    $this.next(".slide-nav__dropdown").slideToggle();
    $this.parent(".slide-nav__item").toggleClass("is_active");
  
    $(".menu_level_2 .slide-nav__dropdown").hide();
    $(".menu_level_2 .slide-nav__item").removeClass("is_active");

    console.log('123');
  });
  $(".menu_level_2 > li > .slide-nav__button").click(function () {
    var $this = $(this);
    $this.next(".slide-nav__dropdown").slideToggle();
    $this.parent(".slide-nav__item").toggleClass("is_active");
  });
});

(function () {
  const enhance = (container) => {
    if (!container || container.dataset.a11yDone) return;

    // Privacy link
    const privacy = container.querySelector('a.privacy');
    if (privacy) privacy.setAttribute('aria-label', 'hCaptcha Privacy Policy');

    // Terms link
    const terms = container.querySelector('a.terms');
    if (terms) terms.setAttribute('aria-label', 'hCaptcha Terms of Service');

    container.dataset.a11yDone = '1';
  };

  // already present hoy to
  const existing = document.getElementById('shop-hcaptcha-badge-container');
  if (existing) enhance(existing);

  // async inject thay to pakado
  const mo = new MutationObserver(() => {
    const el = document.getElementById('shop-hcaptcha-badge-container');
    if (el) {
      enhance(el);
      // aek vaar mali gaya pachi observer band — badge phir phir nahi banti
      if (el.dataset.a11yDone) mo.disconnect();
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();